import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { Container, Row, Col, Nav, Navbar, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BotHeadIcon1 from "../assets/images/games-icon/play3d.png";

import BotHeadIcon6 from "../assets/images/games-icon/cards.png";
import { useSelector } from "react-redux";

import { AiOutlineClose } from "react-icons/ai";
import StarIcon from "../assets/images/icons/Gold-Shine-PNG-Image.png";

import SlotsIconnew from "../assets/images/icons/jackpot.png";

import GamesSearchModal from "../views/components/GamesSearchModal";
import logo from "../assets/images/logo.webp";
import TextLogo from "../assets/images/logo-text.png";
import LanguageChange from "../views/components/LanguageChange";
import { ImCross } from "react-icons/im";

import { getNotifications } from "../redux/app/actions";

import Slots from "../assets/images/games-icon/leftbar/slots.png";
import Sportsbook from "../assets/images/games-icon/leftbar/sports.png";
import CustomLanguageSelector from "../views/components/CustomLanguageSelector";
import { t } from "i18next";
import { getSendOtpUrl } from "../utils/common";

const Header = () => {
  //test
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const navigate = useNavigate();
  const isApk = localStorage.getItem("isApk") === "true";
  const { appDetails } = useSelector((state) => state.app);
  const [visible, setVisible] = useState(true);
  const [isLanguageShow, setIsLanguageShow] = useState(true);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);
  const [showToggle, setShowToggle] = useState(true);
  const isEmailOtpRequired = appDetails?.IS_EMAIL === 1;

  const [fontConfig, setFontConfig] = useState({
    counter: 0,
    fontSize: 14,
    type: "inc",
  });

  useEffect(() => {
    if (visible) {
      document.body.classList.add("welcome_note");
    } else {
      document.body.classList.remove("welcome_note");
    }
  }, [visible]);

  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const headerPages = ["betby", "sports-exchange"];
  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  useEffect(() => {
    setShowToggle(window.screen.width > 992);
    loadNotifications();
    return () => {};
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {" "}
            {websiteNotifications.map((notf, idx) => (
              <label>
                <img src={StarIcon} alt="star icon" />
                {notf?.content}
                <img src={StarIcon} alt="star icon" />
              </label>
            ))}
          </marquee>
          <span onClick={() => setVisible(!visible)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}

      <header className="header beforeheader">
        <div className="top_head">
          <Container fluid>
            <Row>
              <Col xs={12}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="logo">
                    <a href="/">
                      <img src={appDetails?.LOGO_URL || logo} alt="Logo" />
                      {/* <img src={TextLogo} alt="Logo" className="logotext" /> */}
                    </a>
                  </div>

                  <div className="headerRight headerrightsec HeaderBeforeLogin">
                    {/* <div className="head-links d-none d-lg-flex">
                      <a href="/slots-games">
                        <img src={Slots} alt="slots" />
                        <span>{t ("slots")}</span>
                      </a>
                      <a href="/atlas-lobby">
                        <img src={Sportsbook} alt="sportsbook" />
                        <span>{t ("sportsbook")}</span>
                      </a>
                    </div> */}

                    <div className="LanguageCancelSection">
                      {/* <CustomLanguageSelector/> */}

                      <div className={isLanguageShow ? "" : "d-none"}>
                        <LanguageChange />
                      </div>
                      {isLanguageShow && (
                        <div
                          style={{ marginRight: "5px", cursor: "pointer" }}
                          onClick={() => setIsLanguageShow((prev) => !prev)}
                          className="LanguageCancel"
                        >
                          <ImCross />
                        </div>
                      )}
                    </div>
                    <GamesSearchModal />

                    <ul className="d-flex d-md-none me-2">
                      {/* <li>
                        <a href="#">
                          <img src={SearchIcon} />
                        </a>
                      </li> */}
                    </ul>

                    <Button
                      variant="primary"
                      onClick={() => {
                        navigate("/sign-in");
                      }}
                      className="button-primary btn_signin"
                    >
                      <span>{t("signIn")}</span>
                    </Button>

                    <div className="Signupanimation login-signup-btn">
                      <Button
                        variant="primary"
                        onClick={() => {
                          navigate(getSendOtpUrl(isEmailOtpRequired));
                        }}
                        className="button-primary btn_signup  btn-secondary ms-2"
                      >
                        <span>{t("register")}</span>
                      </Button>
                      <div className="authorization__animation-item firstChild"></div>
                      <div className="authorization__animation-item secondChild"></div>
                      <div className="authorization__animation-item thirdChild"></div>
                      <div className="authorization__animation-item fourthChild"></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="bottom_head">
          <Container fluid>
            <Row>
              <Col xs={12} className="px-0">
                <ul style={{ fontSize: `${fontConfig.fontSize}px` }}>
                  <li>
                    <a
                      href="/beforeexchange"
                      className={activePage == "betby" ? "active" : ""}
                    >
                      <img
                        src={BotHeadIcon1}
                        alt="bottom head link icon"
                        className="inplay"
                      />
                      <span>{t("inplay")}</span>
                    </a>
                  </li>

                  <li>
                    <a href="/beforeprovider">
                      <img
                        src={SlotsIconnew}
                        alt="bottom head link icon"
                        className=""
                      />
                      <span>{t("casino")}</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="/beforeexchange"
                      className={
                        activePage == "sports-exchange" ? "active" : ""
                      }
                    >
                      <img src={BotHeadIcon6} alt="bottom head link icon" />
                      <span>{t("exchange")}</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="/promotions"
                      className={activePage == "betby" ? "active" : ""}
                    >
                      <img
                        src={BotHeadIcon1}
                        alt="bottom head link icon"
                        className="inplay"
                      />
                      <span>{t("promotions")}</span>
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </div>
      </header>
    </>
  );
};

export default Header;
